<div class="video-container bg-info">
  <div [id]="playerId"></div>
  @if (hasError()) {
  <div class="w-100 h-100 d-flex justify-content-center align-items-center">
    <h4>Unable to load video</h4>
  </div>
  }
</div>
